module.exports = __webpack_public_path__ + "static/job-banner1-f01a5eb09c3b28b67c4c1077fee83007.png";